// Named color variables
// Can be used directly through color variable or type variable

// Neutrals
const COLOR_WHITE = '#FFF';

const COLOR_GRAY_TINT_80 = '#FDFDFE';
const COLOR_GRAY_TINT_60 = '#FBFBFC';
const COLOR_GRAY_TINT_40 = '#F8FAFB';
const COLOR_GRAY_TINT_20 = '#F6F8F9';

const COLOR_GRAY = '#F4F6F8';
const BASIC_GRAY = '#E2E2E2';

const COLOR_GRAY_SHADE_10 = '#DCDDDF';
const COLOR_GRAY_SHADE_20 = '#C3C5C6';
const COLOR_GRAY_SHADE_30 = '#ABACAE';
const COLOR_GRAY_SHADE_40 = '#929495';
const COLOR_GRAY_SHADE_60 = '#626263';
const COLOR_GRAY_SHADE_70 = '#494A4A';
const COLOR_GRAY_SHADE_80 = '#313132';
const COLOR_GRAY_SHADE_90 = '#181919';

const COLOR_BLACK = '#000';

// RGBA
const COLOR_LIGHT_GRAY_TRANSPARENT = 'rgb(244, 246, 248, 0.6)';
const COLOR_GRAY_TRANSPARENT = 'rgb(0, 0, 0, 0.1)';

// Colors
const COLOR_DARK_RED = '#851D1D';
const COLOR_RED = '#BE2A2A';
const COLOR_LIGHT_RED = '#F9EAEA';

const COLOR_PINK = '#FFE2E9';
const COLOR_LIGHT_PINK = '#FCEFEE';
const COLOR_DARK_PINK = '#FBE0DE';

const COLOR_LIGHT_BABY_PINK = '#FFF1F4';

const COLOR_BABY_BLUE = '#E2F3FD';
const COLOR_LIGHT_BABY_BLUE = '#F4F9FE';
const COLOR_DARK_BABY_BLUE = '#E6F0FA';
const COLOR_LIGHT_BLUE = '#F5F9FF';

const WARNING_YELLOW = '#FCE7CD';

const COLOR_LIGHTEST_MINT_GREEN = '#EBF6F5';
const COLOR_LIGHT_MINT_GREEN = '#C6E2DE';
const COLOR_DARK_MINT_GREEN = '#00A393';

const COLOR_LIGHT_GREEN = '#EAF8E5';
const COLOR_LIGHT_GREEN_2 = '#EAF9EE';
const COLOR_GREEN = '#25A84A';
const COLOR_DARK_GREEN = '#1A7634';
const COLOR_SUCCESS_LIGHT_GREEN = '#CBF7D1';

const COLOR_TURQUOISE = '#00ECFF';

// Focus colors
const COLOR_ORANGE = '#EF5803';
const COLOR_YELLOW = '#f3bb00';
const COLOR_RED_FIRE = '#E30613';

const COLOR_PURPLE = '#8455bb';
const COLOR_LIGHT_PURPLE = '#F7EBFF';

export const COLORS = {
  /**
   * BRAND THEME COLORS
   *
   * these colors should only be used through theme colors
   **/

  INTER_PRIMARY_DARK: '#224091',
  INTER_PRIMARY_MEDIUM: '#004DC2',
  INTER_PRIMARY: '#0066FF',
  INTER_PRIMARY_LIGHT: '#F2F7FF',
  INTER_PRIMARY_LIGHT_MEDIUM: '#E8F0FD',
  INTER_PRIMARY_LIGHT_DARK: '#A5C1EB',
  INTER_PRIMARY_TRANSPARENT: 'rgb(34, 64, 145, 0.7)',
  INTER_HOVER: '#F2F7FF',

  BUDGET_PRIMARY_DARK: '#740a09',
  BUDGET_PRIMARY_MEDIUM: '#B00F0C',
  BUDGET_PRIMARY: '#E81411',
  BUDGET_PRIMARY_LIGHT: '#FEF4F4',
  BUDGET_PRIMARY_LIGHT_MEDIUM: '#FBEBEB',
  BUDGET_PRIMARY_LIGHT_DARK: '#E5ABAA',
  BUDGET_PRIMARY_TRANSPARENT: 'rgb(116, 10, 9, 0.7)',
  BUDGET_HOVER: '#FEF4F4',

  /**
   * GENERAL COLOR VARIABLES FOR ALL CHAINS
   **/

  // Third party service colors
  VIMEO: '#1AB7EA',
  YOUTUBE: '#FF0000',
  VIDEOLY: '#797EE8',

  // Neutrals, white to black
  WHITE: COLOR_WHITE,

  GRAY_TINT_80: COLOR_GRAY_TINT_80,
  GRAY_TINT_60: COLOR_GRAY_TINT_60,
  GRAY_TINT_40: COLOR_GRAY_TINT_40,
  GRAY_TINT_20: COLOR_GRAY_TINT_20,

  GRAY: COLOR_GRAY,
  BASIC_GRAY: BASIC_GRAY,

  GRAY_SHADE_10: COLOR_GRAY_SHADE_10,
  GRAY_SHADE_20: COLOR_GRAY_SHADE_20,
  GRAY_SHADE_30: COLOR_GRAY_SHADE_30,
  GRAY_SHADE_40: COLOR_GRAY_SHADE_40,
  GRAY_SHADE_60: COLOR_GRAY_SHADE_60,
  GRAY_SHADE_70: COLOR_GRAY_SHADE_70,
  GRAY_SHADE_80: COLOR_GRAY_SHADE_80,
  GRAY_SHADE_90: COLOR_GRAY_SHADE_90,

  BLACK: COLOR_BLACK,

  // Transparent
  LIGHT_GRAY_TRANSPARENT: COLOR_LIGHT_GRAY_TRANSPARENT,
  GRAY_TRANSPARENT: COLOR_GRAY_TRANSPARENT,

  // Colors
  DARK_RED: COLOR_DARK_RED,
  RED: COLOR_RED,
  LIGHT_RED: COLOR_LIGHT_RED,

  PINK: COLOR_PINK,
  LIGHT_PINK: COLOR_LIGHT_PINK,
  DARK_PINK: COLOR_DARK_PINK,

  LIGHT_BABY_PINK: COLOR_LIGHT_BABY_PINK,

  BABY_BLUE: COLOR_BABY_BLUE,
  LIGHT_BABY_BLUE: COLOR_LIGHT_BABY_BLUE,
  DARK_BABY_BLUE: COLOR_DARK_BABY_BLUE,

  LIGHT_BLUE: COLOR_LIGHT_BLUE,

  WARNING_YELLOW: WARNING_YELLOW,

  LIGHTEST_MINT_GREEN: COLOR_LIGHTEST_MINT_GREEN,
  LIGHT_MINT_GREEN: COLOR_LIGHT_MINT_GREEN,
  DARK_MINT_GREEN: COLOR_DARK_MINT_GREEN,

  LIGHT_GREEN: COLOR_LIGHT_GREEN,
  LIGHT_GREEN_2: COLOR_LIGHT_GREEN_2,
  GREEN: COLOR_GREEN,
  DARK_GREEN: COLOR_DARK_GREEN,

  PURPLE: COLOR_PURPLE,
  LIGHT_PURBLE: COLOR_LIGHT_PURPLE,

  TURQUOISE: COLOR_TURQUOISE,

  /**
   * TYPE VARIABLES
   **/
  NAVBAR_SHADOW: COLOR_GRAY_TRANSPARENT,
  PRODUCT_CONTINUOUS_COLOR: COLOR_DARK_MINT_GREEN,

  PRICE_MARGIN_BG: COLOR_LIGHT_GREEN,
  PRICE_MARGIN: COLOR_BLACK,
  PRICING_CIRCLE_BG: COLOR_WHITE,

  ERROR: COLOR_RED,
  ERROR_BG: COLOR_LIGHT_RED,
  ERROR_DARK: COLOR_DARK_RED,

  SUCCESS: COLOR_GREEN,
  SUCCESS_DARK: COLOR_DARK_GREEN,
  SUCCESS_BG: COLOR_LIGHT_GREEN_2,
  SUCCESS_LIGHT: COLOR_SUCCESS_LIGHT_GREEN,

  BG_LIGHT_MAIN: COLOR_GRAY_TINT_60,
  BORDER_MAIN: COLOR_GRAY_SHADE_10,

  TEXT_LABEL: COLOR_GRAY_SHADE_60,
  FORM_INPUT_LABEL: COLOR_GRAY_SHADE_40,

  NAV_LINK: COLOR_GRAY_SHADE_40,

  OVERLAY_BG: COLOR_LIGHT_GRAY_TRANSPARENT,

  DISABLED_LINK: COLOR_GRAY_SHADE_40,
  DISABLED_BUTTON_BG: COLOR_GRAY_SHADE_10,

  FOCUS_ORANGE: COLOR_ORANGE,
  FOCUS_YELLOW: COLOR_YELLOW,
  FOCUS_RED: COLOR_RED_FIRE,
  FOCUS_GREEN: COLOR_GREEN,
  FOCUS_PURPLE: COLOR_PURPLE,

  TEST_ENV: COLOR_TURQUOISE,
};
